import React from 'react';
import Plot from 'react-plotly.js';
import { MetricWithSeries } from '../../../api/adminDashboard';
import DashboardCard from './DashboardCard';
import MetricHeader from './MetricHeader';
import { CHART_BLUE, CHART_CONFIG, chartLayout, seriesLabels, seriesValues } from './chartTheme';

interface UsageTrendsCardProps {
    usageTrends: MetricWithSeries;
}

const UsageTrendsCard: React.FC<UsageTrendsCardProps> = ({ usageTrends }) => (
    <DashboardCard title="Usage Trends" className="ad-card-chart ad-col-usage">
        <div className="ad-card-body">
            <MetricHeader displayValue={usageTrends.displayValue} deltaPct={usageTrends.deltaPct} />
            <div className="ad-chart">
                <Plot
                    data={[
                        {
                            type: 'scatter',
                            mode: 'lines+markers',
                            x: seriesLabels(usageTrends.series),
                            y: seriesValues(usageTrends.series),
                            line: { color: CHART_BLUE, width: 2, shape: 'spline', smoothing: 1 },
                            marker: { color: CHART_BLUE, size: 6 },
                        },
                    ]}
                    layout={chartLayout()}
                    config={CHART_CONFIG}
                    style={{ width: '100%', height: '100%' }}
                    useResizeHandler={true}
                />
            </div>
        </div>
    </DashboardCard>
);

export default UsageTrendsCard;
